// PageTracker.tsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCurrentBreakpoint } from './hooks/useCurrentBreakpoint';
import { analytics } from './services/analyticsService';
import { useAuthStore } from '../../store/useAuthStore3';

export const PageTracker = () => {
  const location = useLocation();
  const { userId, isLoading } = useAuthStore();
  const currentBreakpoint = useCurrentBreakpoint();

  useEffect(() => {
    // console.log('[PageTracker] useEffect triggered. userId:', userId, 'path:', location.pathname);
    if (isLoading || !userId) return;
    analytics.trackPageView(userId, location.pathname, currentBreakpoint);
  }, [location.pathname, userId, isLoading, currentBreakpoint]);

  return null; // Компонент ничего не рендерит, он только логирует
};